import { FC, ReactNode } from 'react';

import { Box, Text } from '@mantine/core';

import { Container } from '@marketing/components/container/Container';

import cx from './ProfileNotice.module.scss';

const ProfileNotice: FC<{
    title: ReactNode;
    children: ReactNode;
    action?: ReactNode;
    color?: 'black' | 'brand';
}> = ({ title, children, action, color = 'black' }) => (
    <Box className={cx.root} data-color={color}>
        <Container padding="x">
            <Box className={cx.content}>
                <Box>
                    <Text inherit fw={700}>
                        {title}
                    </Text>
                    <Text inherit>{children}</Text>
                </Box>
                {action}
            </Box>
        </Container>
    </Box>
);

export { ProfileNotice };
